import { type ComponentPropsWithoutRef } from "react";

import { Textarea as BaseTextarea } from "../ui/textarea";
import { cn } from "../lib/utils";

import { FieldError } from "./FieldError";
import Icon from "./Icon";

type TextareaProps = {
	iconName: string;
	error?: string;
} & ComponentPropsWithoutRef<"textarea">;

export default function Textarea({ iconName, className, error, ...props }: TextareaProps) {
	return (
		<div className="w-full">
			<div className="group relative">
				<span
					className="pointer-events-none absolute left-4 top-6 flex w-6 items-start justify-center text-muted-foreground transition-colors group-hover:text-primary"
					aria-hidden="true"
				>
					<Icon src={iconName} size={18} />
				</span>
				<BaseTextarea
					aria-invalid={error ? true : undefined}
					className={cn(
						"min-h-[12rem] bg-white pl-12 pt-6 text-[18px] placeholder:text-[18px] transition-all duration-200 border border-input hover:border-2 hover:border-primaryGreen hover:shadow-[0_15px_20px_0_rgba(0,0,0,0.15)] focus-visible:border-2 focus-visible:border-[#699F11] focus-visible:ring-0 focus-visible:shadow-[0_15px_20px_0_rgba(0,0,0,0.15)]",
						error &&
							"border-red-500 hover:border-red-500 focus-visible:border-red-500",
						className,
					)}
					{...props}
				/>
			</div>
			<FieldError message={error} />
		</div>
	);
}
